export var en = {
  formats: {
    date: "mm/dd/yyyy"
  },
  texts: {
    lsg: {
      component: {
        _general: {
          optional: "optional"
        },
        BankingCard: {
          titles: {
            giro: "Girocard"
          },
          cardNumber: "Card-No.",
          validThru: "Valid thru"
        },
        InputDatepicker: {
          placeholder: "MM/DD/YYYY",
          label: "Date",
          error: "Please enter a valid date at the format {{format}}."
        },
        InputSelect: {
          error: "Please select an option.."
        },
        Stage: {
          scrollerText: "Read more..."
        }
      },
      icon: {
        _default: "icon",
        banking_banknote_euro: "banknote euro",
        banking_creditcard_multiple: "credit cards",
        banking_graphs_graph: "graphs",
        banking_atm: "automatic teller maschine",
        banking_transferslip: "transfer slip",
        basics_eye_view: "eye",
        basics_people_group: "group",
        basics_person_female: "female",
        basics_person_male: "male",
        basics_person_profile: "profile",
        basics_person_wheelchair: "wheelchair",
        basics_settings_gear: "settings gear",
        basics_arrow: "arrow",
        basics_calender: "calender",
        basics_checklist: "checklist",
        basics_checkmark: "checkmark",
        basics_clock: "clock",
        interaction___close: "close",
        basics_download: "download",
        basics_error: "error",
        basics_exclamationmark: "exclamation mark",
        basics_fingerprint: "fingerprint",
        basics_house: "house",
        symbols___infoCircle: "infocircle",
        basics_info: "info",
        basics_legal: "legal",
        basics_lightbulb: "light bulb",
        basics_lock: "lock",
        basics_music: "music",
        basics_paperclip: "paper clip",
        basics_pencil: "pencil",
        basics_percentage: "percentage",
        basics_playbutton: "play button",
        basics_questionmark: "question mark",
        basics_refresh: "refresh",
        basics_search: "search",
        basics_shoppingcart: "shopping cart",
        basics_upload: "upload",
        basics_volume: "volume",
        communication_feedback_like: "feedback like",
        communication_mail_envelope: "envelope",
        communication_wifi_on: "wifi on",
        communication_call: "call",
        communication_chat: "chat",
        communication_textchat: "text chat",
        devices_headset: "headset",
        devices_laptop: "laptop",
        devices_smartphone: "smartphone",
        devices_tablet: "tablet",
        location_globe: "globe",
        location_location: "location"
      }
    }
  }
};